import React, { useState } from "react";
import validator from 'validator'
import { v4 as uuid } from 'uuid';

import { Modal } from "reactstrap";
import { toast } from 'react-toastify';

import "assets/css/home-modern.css";
import "assets/css/flow.css";

import DefaultFooter from "components/Footers/DefaultFooter.js";
import IndexNavbar from "components/Navbars/IndexNavbar";
import FlowHero from "components/Flow/FlowHero";
import FlowEmpty from "components/Flow/FlowEmpty";
import QtyStepper from "components/Flow/QtyStepper";
import SummaryBar from "components/Flow/SummaryBar";
import ProductSearch from "components/Flow/ProductSearch";
import { useBusySpan } from "hooks/useBusy";
import { APIRequest, errorHandlerNew } from "utils/ApiRequest";
import { filterProducts, hasQuery } from "utils/productSearch";
import { formatINR } from "utils/format";
import { remainingMemberPasses, repriceDailyPassSelection } from "utils/dailyPassPricing";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

import heroImage from "assets/img/banner0.jpg";

const FLOW_STEPS = ["Select passes", "Review & pay"];
const SUGGESTED_AMOUNTS = [501, 1001, 2501, 5001];

function DailyPassPage() {
  const [membershipProducts, setMembershipProducts] = React.useState(null);
  const [selectedPrds, setSelectedPrds] = useState({});
  const [modalLive, setModalLive] = React.useState(false);
  const [donationModal, setDonationModal] = React.useState(false);
  const [query, setQuery] = useState("");
  // Which tile is showing its description; the panel covers the card face, so only ever one.
  const [infoFor, setInfoFor] = useState(null);

  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [mobile, setMobile] = useState(null);
  const [amount, setAmount] = React.useState(0);
  const [token, setToken] = useState(null);
  const [password, setPassword] = useState(null);
  const [utsavCount, setUtsavCount] = useState(0);
  const [purchasedCounts, setPurchasedCounts] = useState({});
  const [pricingReady, setPricingReady] = useState(false);
  const [pricingError, setPricingError] = useState(false);
  const setBusy = useBusySpan();


  const history = useNavigate();

  React.useEffect(() => {
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    let userInfo = localStorage.getItem('user-info');
    if (userInfo != null) {
      userInfo = JSON.parse(userInfo);
      if (userInfo.session != null) {
        setToken(userInfo.session);
        loadProducts(userInfo.session);
        let sPrd = localStorage.getItem('selectedPrds');
        if (sPrd != null) {
          setSelectedPrds(JSON.parse(sPrd));
        }
        setModalLive(false);
      } else {
        // setModalLive(true);
        loadProducts(null);
      }
    } else {
      // setModalLive(true);
      loadProducts(null);
    }

    return function cleanup() {
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  function loadProducts(token) {
    if (membershipProducts !== null) {
      return;
    }
    APIRequest(
      token,
      "/getUProducts",
      {},
      (res) => {
        const products = res.data.productsResponses != null
          ? res.data.productsResponses["DAILY_PASS"]
          : null;
        const dailyPasses = products != null ? products : [];
        setMembershipProducts(dailyPasses);
        if (token != null && dailyPasses.length > 0) {
          loadProductPurchaseCounts(token, dailyPasses);
        } else {
          setPricingReady(true);
        }
      },
      () => {
        setMembershipProducts([]);
      }
    );
  }

  function loadProductPurchaseCounts(session, products) {
    setPricingReady(false);
    setPricingError(false);
    APIRequest(
      session,
      "/getProductPurchaseCounts",
      { productIds: products.map((product) => product.id) },
      (res) => {
        setUtsavCount(res.data.membershipCount);
        setPurchasedCounts(res.data.purchasedCounts);
        setPricingReady(true);
      },
      () => setPricingError(true)
    );
  }

  const pricedSelection = React.useMemo(
    () => repriceDailyPassSelection(selectedPrds, membershipProducts, utsavCount, purchasedCounts),
    [selectedPrds, membershipProducts, utsavCount, purchasedCounts]
  );
  const totalCartPrice = Object.values(pricedSelection).reduce((sum, product) => sum + product.price, 0);

  React.useEffect(() => {
    if (!pricingReady) return;
    localStorage.setItem("selectedPrds", JSON.stringify(pricedSelection));
    localStorage.setItem("totalCartPrice", totalCartPrice);
  }, [pricedSelection, totalCartPrice, pricingReady]);

  const changePassQuantity = (product, delta) => {
    if (!pricingReady) return;
    setSelectedPrds((selection) => {
      const quantity = Math.max(0, (selection[product.id]?.qty || 0) + delta);
      const next = { ...selection };
      if (quantity === 0) {
        delete next[product.id];
      } else {
        next[product.id] = { ...selection[product.id], qty: quantity, code: product.code };
      }
      return next;
    });
  };

  const handleProceedWContribute = () => {
    if (amount === undefined || amount === null || amount <= 0) {
      toast.error('Please add the amount to contribute!');
      return;
    }
    const nextSelection = { ...pricedSelection, 84: { qty: 1, price: Number(amount), code: "DNP" } };
    setSelectedPrds(nextSelection);
    submitCart(nextSelection);
  };

  const handleProceedToDonation = (e) => {
    if (selectedPrds === undefined || selectedPrds === null || Object.keys(selectedPrds).length === 0) {
      toast.error('Please select atleast one quantity befor proceeding!');
      return;
    }
    setDonationModal(true);
  }

  const handleProceedToSponsorship = () => submitCart(pricedSelection);

  const submitCart = (selection) => {
    if (!pricingReady) return;
    if (Object.keys(selection).length === 0) {
      toast.error('Please select atleast one quantity before proceeding!');
      return;
    }
    if (token === null) {
      setModalLive(true);
    } else {
      // history("/sponsorship");
      setBusy("Preparing your summary…");
      APIRequest(
        token,
        "/addToCart",
        { productQtys: selection },
        (res) => {
          setBusy(null);
          localStorage.setItem("selectedPrds", JSON.stringify(selection));
          localStorage.setItem("totalCartPrice", Object.values(selection).reduce((sum, product) => sum + product.price, 0));
          history("/dpsummary");
        },
        (err) => {
          setBusy(null);
          try {
            return toast.error(err.data.desc);
          } catch (error) {
            console.log(error);
            toast.error('Seems some internal issue with your network, please check your network!');
          }
        }
      );
    }
  }

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleStartOver = (e) => {
    localStorage.removeItem('selectedPrds');
    localStorage.removeItem('totalCartPrice');
    setSelectedPrds({});
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleMobileChange = (e) => {
    setMobile(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  function handleProceedSubmit() {
    if ((email === null || email === "")
      || (mobile === null || mobile === "")
      || (name === null || name === "")) {
      toast.error('All fields are Mandatory!');
    }
    else if (!isValidEmail(email)) {
      toast.error('Please enter a valid email!');
    } else {
      let iid = uuid();
      setBusy("Creating your account…");
      APIRequest(
        null,
        "/signUpAndLogin",
        {
          name, mobile, email, password, iid
        },
        (res) => {
          setToken(res.data.session);
          loadProductPurchaseCounts(res.data.session, membershipProducts);
          localStorage.setItem('user-info', JSON.stringify(res.data));
          setBusy(null);
          setModalLive(false);
        },
        (err) => {
          setBusy(null);
          errorHandlerNew(err);
        }
      );
    }
  }

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  }

  function isValidEmail(email) {
    return validator.isEmail(email);
  }

  const availablePasses = membershipProducts != null
    ? membershipProducts.filter((mprd) => mprd.available)
    : null;

  const visiblePasses = filterProducts(availablePasses, query);
  const isSearching = hasQuery(query);

  const itemCount = Object.keys(selectedPrds)
    .reduce((sum, key) => sum + (selectedPrds[key].qty || 0), 0);

  React.useEffect(() => {
    if (infoFor == null) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setInfoFor(null);
    };
    document.addEventListener("keydown", onKey);
    return function cleanup() {
      document.removeEventListener("keydown", onKey);
    };
  }, [infoFor]);

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <FlowHero
          image={heroImage}
          eyebrow="Coupons & Offerings"
          title="Daily Passes & Offerings"
          lead="Pick your passes for the days you are joining us. Utsav members automatically get their member rate where applicable."
          steps={FLOW_STEPS}
          activeStep={0}
        />
        <div className="main hm hm-flow">
          <section className="hm-fbody">
            <div className="hm-wrap">
              {availablePasses == null && (
                <div className="hm-fstate">
                  <span className="hm-spinner" aria-hidden="true"></span>
                  <p style={{ margin: 0 }}>Loading passes…</p>
                </div>
              )}

              {availablePasses != null && availablePasses.length === 0 && (
                <FlowEmpty
                  icon="now-ui-icons ui-1_calendar-60"
                  title="Passes are not on sale yet"
                  message="Daily passes and offerings for this year's Durgotsav have not opened yet. Please check back shortly — this page will list everything as soon as they go live."
                >
                  <Link className="hm-btn hm-btn-primary" to="/index">
                    Back to home
                  </Link>
                </FlowEmpty>
              )}

              {availablePasses != null && availablePasses.length > 0 && (
                <>
                  {pricingReady && utsavCount > 0 && (
                    <div className="hm-notice">
                      <span className="hm-notice-ico" aria-hidden="true">
                        <i className="now-ui-icons objects_diamond"></i>
                      </span>
                      <div className="hm-notice-body">
                        <h3>Your Utsav member rate is active</h3>
                        <ul>
                          <li>
                            You have <b>{utsavCount}</b> Utsav {utsavCount === 1 ? "membership" : "memberships"}{" "}
                            this fiscal year. Each offering has its own member-rate allowance.
                          </li>
                          <li>Previously purchased passes reduce the allowance for that offering. Additional passes use the standard rate.</li>
                        </ul>
                      </div>
                    </div>
                  )}

                  {!pricingReady && (
                    <div className="hm-fstate" role="status">
                      {pricingError ? (
                        <>
                          <p>Could not load your member pricing.</p>
                          <button className="hm-btn hm-btn-outline" type="button"
                            onClick={() => loadProductPurchaseCounts(token, membershipProducts)}>
                            Retry member pricing
                          </button>
                        </>
                      ) : <p>Loading your member pricing…</p>}
                    </div>
                  )}

                  <ProductSearch
                    id="dailypass-search"
                    value={query}
                    onChange={setQuery}
                    placeholder="Search passes by name or day…"
                    label="Search daily passes and offerings"
                    noun={availablePasses.length === 1 ? "item" : "items"}
                    resultCount={visiblePasses.length}
                    totalCount={availablePasses.length}
                  />

                  {isSearching && visiblePasses.length === 0 && (
                    <div className="hm-fstate">
                      <p style={{ margin: 0 }}>
                        No pass or offering matches <b>“{query.trim()}”</b>.
                      </p>
                      <button className="hm-btn hm-btn-outline" type="button" onClick={() => setQuery("")}>
                        Clear search
                      </button>
                    </div>
                  )}

                  {visiblePasses.length > 0 && (
                  <div className="hm-igrid hm-igrid-wide">
                    {visiblePasses.map((mprd) => {
                      const picked = pricedSelection[mprd.id];
                      const memberSlots = remainingMemberPasses(utsavCount, purchasedCounts[mprd.id]);
                      const qty = picked != null ? picked.qty : 0;
                      const lineTotal = picked != null ? picked.price : 0;
                      const hasMemberRate = mprd.coPrice != null
                        && Number(mprd.coPrice) !== Number(mprd.price);
                      return (
                        <article
                          className={"hm-tile" + (qty > 0 ? " is-picked" : "")}
                          key={mprd.id}
                        >
                          <div className="hm-tile-head">
                            <div className="hm-tile-title">
                              <h3 className="hm-tile-name">{mprd.name}</h3>
                              {mprd.desc && (
                                <button
                                  className="hm-tile-i"
                                  type="button"
                                  aria-expanded={infoFor === mprd.id}
                                  aria-controls={"tileInfo" + mprd.id}
                                  aria-label={"About " + mprd.name}
                                  onClick={() => setInfoFor(infoFor === mprd.id ? null : mprd.id)}
                                >
                                  <i className="now-ui-icons travel_info" aria-hidden="true"></i>
                                </button>
                              )}
                            </div>
                          </div>
                          {mprd.desc && infoFor === mprd.id && (
                            <div className="hm-tile-info" id={"tileInfo" + mprd.id}>
                              <div className="hm-tile-info-head">
                                <span>About this offering</span>
                                <button
                                  className="hm-tile-info-x"
                                  type="button"
                                  aria-label="Close"
                                  onClick={() => setInfoFor(null)}
                                >
                                  <span aria-hidden={true}>&times;</span>
                                </button>
                              </div>
                              <p>{mprd.desc}</p>
                            </div>
                          )}
                          <div className="hm-tile-body">
                            {hasMemberRate ? (
                              <div className="hm-prices">
                                <div className={"hm-price-row" + (memberSlots > 0 ? " is-best" : "")}>
                                  <span>
                                    Utsav members
                                    {memberSlots > 0 && <b className="hm-chip">Applied</b>}
                                  </span>
                                  <b>&#x20B9;{formatINR(mprd.coPrice)} <small>/ person</small></b>
                                </div>
                                <div className="hm-price-row">
                                  <span>Others</span>
                                  <b>&#x20B9;{formatINR(mprd.price)} <small>/ person</small></b>
                                </div>
                              </div>
                            ) : (
                              <div className="hm-price">
                                &#x20B9;{formatINR(mprd.price)} <small>/ person</small>
                              </div>
                            )}

                            {hasMemberRate && pricingReady && (
                              <p>{memberSlots} member-rate {memberSlots === 1 ? "pass" : "passes"} remaining for this offering</p>
                            )}
                            <div className="hm-tile-foot">
                              <div className="hm-pick">
                                <span className="hm-pick-l">Quantity</span>
                                <QtyStepper
                                  qty={qty}
                                  label={mprd.name}
                                  disabled={!pricingReady}
                                  increaseDisabled={mprd.utsavOnly && qty >= memberSlots}
                                  onDecrease={() => changePassQuantity(mprd, -1)}
                                  onIncrease={() => changePassQuantity(mprd, 1)}
                                />
                              </div>
                              {qty > 0 && (
                                <p className="hm-pick-sum">
                                  <span>{qty} {qty === 1 ? "pass" : "passes"}</span>
                                  <b>&#x20B9;{formatINR(lineTotal)}</b>
                                </p>
                              )}
                            </div>
                          </div>
                        </article>
                      );
                    })}
                  </div>
                  )}

                  <SummaryBar
                    label="Total"
                    total={totalCartPrice}
                    note={
                      itemCount > 0
                        ? itemCount + (itemCount === 1 ? " item selected" : " items selected")
                        : "Add at least one pass to continue"
                    }
                  >
                    <button
                      className="hm-btn hm-btn-outline hm-btn-quiet"
                      type="button"
                      onClick={handleStartOver}
                      disabled={itemCount === 0 && totalCartPrice === 0}
                    >
                      Clear selection
                    </button>
                    <button className="hm-btn hm-btn-primary" type="button" disabled={!pricingReady} onClick={handleProceedToDonation}>
                      Proceed <i className="now-ui-icons arrows-1_minimal-right"></i>
                    </button>
                  </SummaryBar>
                </>
              )}
            </div>
          </section>
        </div>
        <DefaultFooter />
      </div>

      <Modal
        isOpen={modalLive}
        centered
        contentClassName="hm-modal"
        toggle={() => setModalLive(false)}
      >
        <div className="hm-modal-head">
          <div>
            <span className="hm-modal-eyebrow">One last step</span>
            <h5 className="hm-modal-title">Create your account to continue</h5>
          </div>
          <button
            aria-label="Close"
            className="hm-modal-x"
            type="button"
            onClick={() => setModalLive(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="hm-modal-body">
          <div className="hm-fform">
            <div className="hm-fld">
              <label className="hm-fld-l" htmlFor="dp-name">Full name</label>
              <div className="hm-fld-wrap">
                <input
                  id="dp-name"
                  className="hm-fld-i"
                  type="text"
                  placeholder="Your full name"
                  onChange={handleNameChange}
                />
              </div>
            </div>
            <div className="hm-fld">
              <label className="hm-fld-l" htmlFor="dp-email">Email</label>
              <div className="hm-fld-wrap">
                <input
                  id="dp-email"
                  className="hm-fld-i"
                  type="email"
                  placeholder="you@example.com"
                  onChange={handleEmailChange}
                />
              </div>
            </div>
            <div className="hm-fld">
              <label className="hm-fld-l" htmlFor="dp-mobile">Mobile</label>
              <div className="hm-fld-wrap">
                <input
                  id="dp-mobile"
                  className="hm-fld-i"
                  type="tel"
                  placeholder="10-digit mobile number"
                  onChange={handleMobileChange}
                />
              </div>
            </div>
            <div className="hm-fld">
              <label className="hm-fld-l" htmlFor="dp-password">Password</label>
              <div className="hm-fld-wrap">
                <input
                  id="dp-password"
                  className="hm-fld-i"
                  type="password"
                  placeholder="Choose a password"
                  onChange={handlePasswordChange}
                />
              </div>
            </div>
          </div>
          <p className="hm-modal-alt">
            Already registered? <Link to="/login">Login here</Link>
          </p>
        </div>
        <div className="hm-modal-foot">
          <button className="hm-btn hm-btn-primary" type="button" onClick={handleProceedSubmit}>
            Create account &amp; continue
          </button>
        </div>
      </Modal>

      <Modal isOpen={donationModal} centered contentClassName="hm-modal">
        <div className="hm-modal-head">
          <div>
            <span className="hm-modal-eyebrow">Optional</span>
            <h5 className="hm-modal-title">Add a contribution to the Pujo</h5>
          </div>
          <button
            aria-label="Close"
            className="hm-modal-x"
            type="button"
            onClick={() => setDonationModal(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="hm-modal-body">
          <p>
            Any additional amount towards the <b>Puja Mantap</b> or <b>Community Bhog</b> is
            deeply valued by SORRBA — every rupee goes back into the celebration.
          </p>
          <div className="hm-fld">
            <label className="hm-fld-l" htmlFor="dp-amount">Amount to contribute</label>
            <div className="hm-fld-wrap">
              <span className="hm-fld-pre" aria-hidden="true">&#x20B9;</span>
              <input
                id="dp-amount"
                className="hm-fld-i"
                type="number"
                min="0"
                inputMode="numeric"
                placeholder="0"
                value={amount ? amount : ""}
                onChange={handleAmountChange}
              />
            </div>
            <div className="hm-amts">
              {SUGGESTED_AMOUNTS.map((value) => (
                <button
                  className={"hm-amt" + (Number(amount) === value ? " is-on" : "")}
                  type="button"
                  key={value}
                  onClick={() => setAmount(value)}
                >
                  &#x20B9;{formatINR(value)}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="hm-modal-foot">
          <button className="hm-btn hm-btn-outline" type="button" onClick={handleProceedToSponsorship}>
            Skip &amp; continue
          </button>
          <button className="hm-btn hm-btn-primary" type="button" onClick={handleProceedWContribute}>
            Add contribution
          </button>
        </div>
      </Modal>

    </>
  );
}

export default DailyPassPage;
